<template>
  <div :class="unityPreloaderClass">
    <div class="logo-container">
      <div class="logo2-container">
        <img src="static/preloader/logo_2.png" alt="" @load="onImgLoad2" />
      </div>
      <div class="logo1-container" :style="logo1_style">
        <img src="static/preloader/logo_1.png" alt="" @load="onImgLoad1" />
      </div>
    </div>
    <img src="static/preloader/tag.png" alt="" class="tagImage" />
  </div>
</template>

<script>
export default {
  name: "UnityPreloader.vue",
  props: ["progress", "loadDelay"],
  data() {
    return {
      interval: null,
      currentProgress: 0,
      imgLoaded1: false,
      imgLoaded2: false,
    };
  },

  computed: {
    logo1_style() {
      // console.log(Math.floor((1 - this.currentProgress) * 10000) / 100 + "%");
      return {
        height: Math.floor((1 - this.currentProgress) * 10000) / 100 + "%",
      };
    },
    unityPreloaderClass() {
      let extra_class = this.imgLoaded1 && this.imgLoaded2 ? " loaded" : "";
      return " unity-preloader" + extra_class;
    },
  },
  methods: {
    updateProgress() {
      this.currentProgress += (this.progress - this.currentProgress) * 0.09;
      if (this.progress == 1 && this.currentProgress > 0.99) {
        this.currentProgress = 1;
        clearInterval(this.interval);
        setTimeout(
          function () {
            this.$eventBus.$emit("unityLoaded");
          }.bind(this),
          1000 * this.loadDelay
        );
      }
    },
    onImgLoad2() {
      this.imgLoaded2 = true;
    },
    onImgLoad1() {
      this.imgLoaded1 = true;
    },
  },
  mounted() {
    this.interval = setInterval(this.updateProgress.bind(this), 30);
    setTimeout(
      function () {
        this.$eventBus.$emit("onRequestAudio");
      }.bind(this),
      400
    );
  },
  watch: {
    //progress(old_progress, new_progress) {
    //  console.log(old_progress, new_progress);
    //},
  },
};
</script>

<style scoped>
.unity-preloader {
  background: #101010 url(../assets/images/bg.jpg) center center;
  background-size: cover;
  color: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
}
.unity-preloader .logo-container {
  opacity: 0;
  transition: opacity 0.4s ease-in;
}
.unity-preloader.loaded .logo-container {
  opacity: 1;
}
.logo-container {
  width: 68%;
  position: relative;
  margin: 10% auto 0;
}
.logo1-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.logo1-container img {
  display: block;
}
.logo2-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.logo2-container img {
  display: block;
}
.tagImage {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 30px auto;
  width: 35%;
}
</style>
